import { useMutation } from "@tanstack/react-query"
import { config } from "~/config.ts"
import { axiosPost } from "~/lib"

const BFF_LOGOUT_ENDPOINT = `${config.authBackendForFrontend}/auth/logout`
const SSO_LOGOUT_ENDPOINT = `${config.singleSignOnUrl}/logout`

export type LogoutVariables = {
  redirectUrl?: string
}

export function useLogout() {
  return useMutation<void, Error, LogoutVariables | undefined>({
    mutationFn: async (variables = {}) => {
      const { redirectUrl } = variables
      const encodedRedirectUrl = redirectUrl ? encodeURIComponent(redirectUrl) : undefined

      /* Get current location to open it again when user is logged out.
       When users are logged out, the /logout page redirects users back to the provided post_logout_redirect_uri */
      const currentLocation = encodeURIComponent(window.location.href)

      /* Logout user on the backend for frontend (BFF) side. It also removes session id cookie. */
      await axiosPost({
        url: `${BFF_LOGOUT_ENDPOINT}?post_logout_redirect_uri=${encodedRedirectUrl || currentLocation}`,
      })

      /* Navigate to the logout page of the SSO service. Replace current history entry, as we only want to log out,
         without duplicating the entry in history. */
      window.location.replace(
        `${SSO_LOGOUT_ENDPOINT}?post_logout_redirect_uri=${encodedRedirectUrl || currentLocation}`
      )
    },
  })
}
